import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createExaCustomer, updateExaCustomer, deleteExaCustomer, getExaCustomer, getExaCustomerList } from "@/api/customer";
import { formatTimeToStr } from "@/utils/date";
import infoList from "@/mixins/infoList";
export default {
  name: "Customer",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getExaCustomerList,
      dialogFormVisible: false,
      type: "",
      form: {
        customerName: "",
        customerPhoneData: ""
      }
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    }
  },
  methods: {
    updateCustomer: function updateCustomer(row) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getExaCustomer({
                ID: row.ID
              });
            case 2:
              res = _context.sent;
              _this.type = "update";
              if (res.code == 0) {
                _this.form = res.data.customer;
                _this.dialogFormVisible = true;
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.form = {
        customerName: "",
        customerPhoneData: ""
      };
    },
    deleteCustomer: function deleteCustomer(row) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              row.visible = false;
              _context2.next = 3;
              return deleteExaCustomer({
                ID: row.ID
              });
            case 3:
              res = _context2.sent;
              if (res.code == 0) {
                _this2.$message({
                  type: "success",
                  message: ""
                });
                if (_this2.tableData.length == 1) {
                  _this2.page--;
                }
                _this2.getTableData();
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = _this3.type;
              _context3.next = _context3.t0 === "create" ? 3 : _context3.t0 === "update" ? 7 : 11;
              break;
            case 3:
              _context3.next = 5;
              return createExaCustomer(_this3.form);
            case 5:
              res = _context3.sent;
              return _context3.abrupt("break", 15);
            case 7:
              _context3.next = 9;
              return updateExaCustomer(_this3.form);
            case 9:
              res = _context3.sent;
              return _context3.abrupt("break", 15);
            case 11:
              _context3.next = 13;
              return createExaCustomer(_this3.form);
            case 13:
              res = _context3.sent;
              return _context3.abrupt("break", 15);
            case 15:
              if (res.code == 0) {
                _this3.closeDialog();
                _this3.getTableData();
              }
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    openDialog: function openDialog() {
      this.type = "create";
      this.dialogFormVisible = true;
    }
  },
  created: function created() {
    this.getTableData();
  }
};